export const rules = {
    name: [
        { required: true, message: 'Пожалуйста, введите корпус', trigger: 'blur' },
    ],
};
